import { useMaintenances } from "@/hooks";
import { formatMaintenanceTime } from "@/utils/maintenanceWindow";

import { ErrorMessage } from "./ErrorMessage";

export const ErrorMaintenance = () => {
  const { maintenances } = useMaintenances();

  // The status page's maintenance under way, when its planned end is still ahead.
  const endsAt = maintenances?.find(({ isUnderWay }) => isUnderWay)?.endsAt;
  const comeback =
    endsAt && Date.parse(endsAt) > Date.now()
      ? `expect to be back by ${formatMaintenanceTime(endsAt)}`
      : "will be back shortly";

  return (
    <ErrorMessage
      title="Layer is down for scheduled maintenance"
      description={`We're upgrading our infrastructure and ${comeback}. Follow progress on our status page.`}
      showHelpLinks
    />
  );
};
